import { ActionTypes } from "../../constants/ActionTypes";
import { IItem, ILetterReferParams, ISaveAndSignLetter } from "../../interfaces";

export const onGetLetterTemplate = () => {
    return {
        type: ActionTypes.GET_LETTER_TEMPLATE
    };
};

export const onGetLetterTemplateSuccess = (letterTempaltes: any) => {
    return {
        type: ActionTypes.GET_LETTER_TEMPLATE_SUCCESS,
        payload: letterTempaltes
    };
};

export const onGetLetterDetail = (letterCode: string | undefined) => {
    return {
        type: ActionTypes.GET_LETTER_DETAIL,
        payload: letterCode
    };
};

export const fetchLetterDetailSuccess = (letterDetail: any) => {
    return {
        type: ActionTypes.FETCH_LETTER_DETAIL_SUCCESS,
        payload: letterDetail,
    };
};

export const onGetDraftDetail = (letterCode: string | undefined, taskId?: string | undefined) => {
    return {
        type: ActionTypes.GET_DRAFT_DETAIL,
        payload: {
            letterCode: letterCode,
            taskId: taskId
        }
    };
};

export const fetchDraftDetailSuccess = (draftDetail: any) => {
    return {
        type: ActionTypes.FETCH_DRAFT_DETAIL_SUCCESS,
        payload: draftDetail,
    };
};

export const onGetLetterRefers = (params: ILetterReferParams) => {
    return {
        type: ActionTypes.GET_LETTER_REFERS,
        payload: params
    };
};

export const fetchLetterRefersSuccess = (refersDetail: any[]) => {
    return {
        type: ActionTypes.FETCH_LETTER_REFERS_SUCCESS,
        payload: refersDetail,
    };
};

export const onGetUrgentType = () => {
    return {
        type: ActionTypes.GET_URGENT_TYPE
    };
};

export const fetchUrgentTypeSuccess = (urgentType: any[]) => {
    return {
        type: ActionTypes.FETCH_URGENT_TYPE_SUCCESS,
        payload: urgentType,
    };
};

export const onGetClassificationType = () => {
    return {
        type: ActionTypes.GET_CLASSIFICATION_TYPE
    };
};

export const fetchClassificationTypeSuccess = (classificationType: any[]) => {
    return {
        type: ActionTypes.FETCH_CLASSIFICATION_TYPE_SUCCESS,
        payload: classificationType,
    };
};

export const changeStateItemsValue = (item: IItem) => {
    return {
        type: ActionTypes.CHANGE_STATE_ITEMS_VALUE,
        payload: item,
    }
};

export const changeStateItemsValueWithType = (item: IItem) => {
    return {
        type: ActionTypes.CHANGE_STATE_ITEMS_VALUE_WITH_TYPE,
        payload: item,
    }
};

export const onSave = (draftDetail: any) => {
    return {
        type: ActionTypes.SAVE_LETTER,
        payload: draftDetail
    }
};

export const onSaveSuccess = () => {
    return {
        type: ActionTypes.SAVE_LETTER_SUCCESS
    }
};

export const onGetLetterLocation = (letterCode: string | undefined) => {
    return {
        type: ActionTypes.GET_LETTER_LOCATION,
        payload: letterCode
    };
};

export const fetchLetterLocationSuccess = (LocationDetail: any[]) => {
    return {
        type: ActionTypes.FETCH_LETTER_LOCATION_SUCCESS,
        payload: LocationDetail,
    };
};

export const OnClearDraftReceivers = () => {
    return {
        type: ActionTypes.ON_CLEAR_DRAFT_RECEIVERS,

    };
};

export const onClearDraft = () => {
    return {
        type: ActionTypes.ON_CLEAR_DRAFT,
    };
};